import Component from '../../js/_Component';

const CNAME = 'c-base-form-hidden-input';

export default class BaseFormHiddenInput extends Component {
	private input: HTMLInputElement;

	private parameter: string;

	private parser: URLSearchParams;

	constructor(element: HTMLElement) {
		super(element);

		this.input = element.querySelector('input');
		this.parameter = this.input.dataset.parameter;
		this.parser = new URLSearchParams(window.location.search);

		this.input.value = this.parser.get(this.parameter) || this.input.value;
	}
}

Component.register(BaseFormHiddenInput, 'BaseFormHiddenInput');
